import { Slot } from '@farol-ds/react'
import classNames from 'classnames'
import { LiHTMLAttributes } from 'react'

import styles from './list-block.module.scss'

export type ListBlockItemElement = HTMLLIElement

export type ListBlockItemProps = LiHTMLAttributes<ListBlockItemElement> & {
  disabled?: boolean
  asChild?: boolean
}

function ListBlockItem(props: ListBlockItemProps) {
  const { children, className, disabled = false, asChild, ...rest } = props
  const classes = classNames(
    styles.item,
    {
      [styles.disabled]: disabled,
    },
    className
  )

  const Component = asChild ? Slot : 'li'

  return (
    <Component className={classes} {...rest}>
      {children}
    </Component>
  )
}

export default ListBlockItem
